import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  BaseRequest,
  ResetTransactionAlertsCategoriesRequest,
  UpdateTransactionAlertRequest,
  TransactionAlert,
} from '@/api';
import { ComplianceAlertSettingsData } from '../models';

export interface ComplianceAlertLevelsSliceState {
  data: ComplianceAlertSettingsData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceAlertLevelsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceAlertLevelsSlice = createSlice({
  name: 'complianceAlertLevels',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceAlertSettingsData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    listAlertLevels: (state, actions: PayloadAction<BaseRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    updateSettings: (
      state,
      actions: PayloadAction<UpdateTransactionAlertRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    resetTransactionAlertsCategories: (
      state,
      action: PayloadAction<ResetTransactionAlertsCategoriesRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    updateLevels: (state, action: PayloadAction<TransactionAlert>) => {
      const { category, direction, interactionType, levels } = action.payload;
      const { data } = state;

      if (!data) return;

      if (!data.levels[category]) data.levels[category] = {};

      if (!data.levels[category]![direction]) {
        data.levels[category]![direction] = {};
      }

      data.levels[category]![direction]![interactionType] = {
        low: levels.low ?? null,
        medium: levels.medium ?? null,
        high: levels.high ?? null,
        severe: levels.severe ?? null,
        na: levels.na ?? null,
      };
    },
  },
});

export { complianceAlertLevelsSlice };
